import * as React from 'react';
import { FormattedRelativeTime } from 'react-intl';
import { DateTime } from 'luxon';
import { FormattedMessage } from '@99designs/frontend-components/i18n';
import selectValueAndUnit from '@99designs/frontend-components/i18n/selectValueAndUnit';

export interface Props {
    lastSeenAt: string;
    isOnline: boolean;
}

class OnlineStatus extends React.Component<Props> {
    render() {
        const dateTime = DateTime.fromJSDate(new Date(this.props.lastSeenAt));
        const durationFromNow = dateTime.diffNow();
        const [value, unit] = selectValueAndUnit(durationFromNow);

        return (
            // eslint-disable-next-line react/jsx-no-useless-fragment
            <>
                {this.props.isOnline ? (
                    __('Online now')
                ) : (
                    <FormattedMessage
                        message={__('Online {time}')}
                        values={{
                            time: (
                                <FormattedRelativeTime
                                    value={Math.round(value)}
                                    unit={unit}
                                    numeric="auto"
                                />
                            ),
                        }}
                    />
                )}
            </>
        );
    }
}

export default OnlineStatus;
